/* eslint-disable */
import { Dispatch } from "redux";
import { AppThunk } from "@app/redux/store/root";
import { AppsDetails, AppsModel } from "@app/redux/models";
import {
    getAll,
    create,
    generateKeyPair,
    updateVersioningById,
    updateDetails,
    updateTestCredential,
    getById,
    sortAppScreenshots,
    updateMediaById,
    deleteMediaById,
    getAppVersions,
    getAllOemApps,
    getOemAppsCount,
    updateOemAppCountries,
    getOemAppById,
    updateAppStatus,
    updateOemAppVehicles,
    updateDevAppCountries,
    updatePriceDetails,
    getAllTesterApps,
    getAllTesterAppDetails,
    getTesterAppVersions,
    getValidationReportPerApp,
    getCountries,
    getBrands,
    getVehicleModels,
    registerIV,
    recoverPassword,
    resendPasswordRecoveryEmailApi,
    checkIfEmailCanBeResentNowApi,
    deleteAppApi,
    submitFeedbackApi,
    downloadAPKByVersion,
    fetchAgreementApi,
    uploadCertificateAPI,
    fetchCertificateAPI,
} from "../../services/apps";
import { UPDATE_API_FETCHING } from "../api_details/types";
import {
    CREATE_APP,
    CREATE_APP_VERSION,
    UPDATE_DETAILS_APP,
    RETRIEVE_APPS,
    APP_BY_ID,
    APP_SCREENSHOTS,
    APP_VIDEO,
    APP_ICON,
    APP_VERSIONS,
    APP_COUNTRIES,
    APP_REVOKE_PUBLISH,
    GENERATE_KEY_PAIR,
    UPDATE_TEST_CREDENTIAL,
    SUB_HEADER_TEXT,
    SUB_HEADER_TITLE,
    NO_RESULT_FOUND,
    UPLOAD_CERTIFICATE,
} from "./types";
import { APP_VEHICLES } from ".";
import { updateValidationSubStepStatus } from "@app/redux/services/validation";
import TokenService from "@app/redux/services/token";

export const retrieveApps =
    (page: number, rowsPerPage: number, dataFilter: object) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await getAll(page, rowsPerPage, dataFilter);

            dispatch({
                type: RETRIEVE_APPS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const deleteApp =
    (id: string, token: string) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await deleteAppApi(id, token);

            // dispatch({
            //     type: DELETE_APP,
            //     payload: response.data
            // })

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const createApp =
    (data: FormData): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });

            const response = await create(data);

            dispatch({
                type: CREATE_APP,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const createKeyPair =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            // dispatch({
            //     type: GENERATE_KEY_PAIR,
            //     payload: { status: false }
            // })

            const response = await generateKeyPair(appId, data);
            // dispatch({
            //     type: GENERATE_KEY_PAIR,
            //     payload: response
            // })
            console.log(response);
            return Promise.resolve(response);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: GENERATE_KEY_PAIR,
                payload: { status: false },
            });
        }
    };

export const updateAppDetails =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await updateDetails(appId, data);

            dispatch({
                type: UPDATE_DETAILS_APP,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const updateTestCredentials =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_TEST_CREDENTIAL,
                payload: data,
            });

            const response = await updateTestCredential(appId, data);
            dispatch({
                type: UPDATE_TEST_CREDENTIAL,
                payload: data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const getAppById =
    (id: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await getById(id);

            dispatch({
                type: APP_BY_ID,
                payload: response.data,
            });
        } catch (err) {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });

            if (err.response && err.response.status !== 403) {
                dispatch({
                    type: NO_RESULT_FOUND,
                    payload: { status: true },
                });
            }
            return Promise.reject(err);
        }
    };

export const fetchOemAppById =
    (id: string, versionId: number) =>
    async (dispatch: Dispatch): Promise<void> => {
        try {
            const response = await getOemAppById(id, versionId);

            dispatch({
                type: APP_BY_ID,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err) {
            if (err.response && err.response.status !== 403) {
                dispatch({
                    type: NO_RESULT_FOUND,
                    payload: { status: true },
                });
            }
            return Promise.reject(err);
        }
    };

export const sortAppScreenshotsById =
    (id: string, data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<void> => {
        try {
            const response = await sortAppScreenshots(id, data);

            dispatch({
                type: APP_SCREENSHOTS,
                payload: response.data.screenshots,
            });

            return Promise.resolve(response.data);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const updateAppMediaById =
    (id: string, data: FormData, mediaType: string) =>
    async (dispatch: Dispatch): Promise<AppsDetails> => {
        try {
            const res = await updateMediaById(id, data, (event) => console.log(event));

            if (mediaType === "screenshots") {
                dispatch({
                    type: APP_SCREENSHOTS,
                    payload: res.data.data.screenshots,
                });
            }

            if (mediaType === "icon") {
                dispatch({
                    type: APP_ICON,
                    payload: res.data.data,
                });
            }

            return Promise.resolve(res.data.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const deleteAppMediaById =
    (id: string, data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<AppsDetails> => {
        try {
            const res = await deleteMediaById(id, data);

            if (data["screenshots"]) {
                dispatch({
                    type: APP_SCREENSHOTS,
                    payload: res.data.screenshots,
                });
            }

            if (data["videos"]) {
                dispatch({
                    type: APP_VIDEO,
                    payload: res.data.videos,
                });
            }

            return Promise.resolve(res.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const retrieveAppVersions =
    (id: string, page: number, rowsPerPage: number) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            //dispatch({
            //    type: UPDATE_API_FETCHING,
            //    payload: { status: true }
            //})

            const response = await getAppVersions(id, page, rowsPerPage);

            dispatch({
                type: APP_VERSIONS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            //dispatch({
            //    type: UPDATE_API_FETCHING,
            //    payload: { status: false }
            //})
        }
    };

export const createAppVersion =
    (id: string, data: FormData) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const res = await updateVersioningById(id, data, (event) => console.log(event));

            dispatch({
                type: CREATE_APP_VERSION,
                payload: res.data.data,
            });

            return Promise.resolve(res.data.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const retrieveOemAppsCount =
    (data: Record<string, unknown>, excludeAppsWithZeroDownloads = false) =>
    async (): Promise<any> => {
        try {
            const response = await getOemAppsCount(data, excludeAppsWithZeroDownloads);
            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const retrieveOemApps =
    (
        data: Record<string, unknown>,
        excludeAppsWithZeroDownloads = false,
        excludeAppsThatAreNeitherPublishedNorRevoked = false
    ) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await getAllOemApps(data, excludeAppsWithZeroDownloads);

            if (response.data.data.length > 0 && excludeAppsWithZeroDownloads) {
                response.data.data = response.data.data.filter((app: any) => app.downloads !== 0);
                response.data.totalRecords = response.data.data.length;
            }

            if (response.data.data.length > 0 && excludeAppsThatAreNeitherPublishedNorRevoked) {
                response.data.data = response.data.data.filter((app: any) => app.oemAppStatus);
                response.data.totalRecords = response.data.data.length;
            }

            dispatch({
                type: RETRIEVE_APPS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const updateDevAppCountriesById =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await updateDevAppCountries(appId, data);

            dispatch({
                type: APP_COUNTRIES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const updateAppCountriesById =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await updateOemAppCountries(appId, data);

            dispatch({
                type: APP_COUNTRIES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const updateAppVehiclesById =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await updateOemAppVehicles(appId, data);

            dispatch({
                type: APP_VEHICLES,
                payload: response.data.data,
            });

            return Promise.resolve(response.data.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const revokeApp =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await updateAppStatus(appId, data);

            dispatch({
                type: APP_REVOKE_PUBLISH,
                payload: {
                    status: 2,
                },
            });

            return Promise.resolve(response);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const publishApp =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await updateAppStatus(appId, data);

            dispatch({
                type: APP_REVOKE_PUBLISH,
                payload: {
                    status: 1,
                },
            });

            return Promise.resolve(response);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const updateAppPriceDetails =
    (appId: string, data: Record<string, unknown>): AppThunk =>
    async (dispatch): Promise<any> => {
        try {
            const response = await updatePriceDetails(appId, data);

            const priceDetails = [
                {
                    price: data.price,
                },
            ];

            dispatch({
                type: UPDATE_DETAILS_APP,
                payload: {
                    data: {
                        prices: priceDetails,
                    },
                },
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const retrieveTesterApps =
    (data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await getAllTesterApps(data);

            dispatch({
                type: RETRIEVE_APPS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const getTesterAppDetails =
    (appId: string, versionId: string) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            const response = await getAllTesterAppDetails(appId, versionId);

            dispatch({
                type: APP_BY_ID,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            if (err.response && err.response.status !== 403) {
                dispatch({
                    type: NO_RESULT_FOUND,
                    payload: { status: true },
                });
            }
            return Promise.reject(err);
        }
    };

export const retrieveTesterAppVersions =
    (id: string, page: number, rowsPerPage: number) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            const response = await getTesterAppVersions(id, page, rowsPerPage);

            dispatch({
                type: APP_VERSIONS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const updateValidationSubStep =
    (id: string, data: any) =>
    async (dispatch: Dispatch): Promise<AppsModel> => {
        try {
            const response = await updateValidationSubStepStatus(id, data);

            dispatch({
                type: APP_VERSIONS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

//export const toggleAppDetailsFormConfirmation = (status = false) => (dispatch: Dispatch): void => {
//  console.log(`Here status: ${status}`)
//  dispatch({
//    type: SHOW_FORM_MODAL_CONFIRMATION,
//    payload: status
//  })
//}

export const retrieveValidationReportPerApp =
    (id: string) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await getValidationReportPerApp(id);

            dispatch({
                type: APP_VERSIONS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const setSubHeaderText =
    (text: string) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: SUB_HEADER_TEXT,
            payload: text,
        });
    };

export const setSubHeaderTitle =
    (payload: object) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: SUB_HEADER_TITLE,
            payload: payload,
        });
    };

export const getAllCountries = async (id: string) => {
    try {
        const response = await getCountries(id);
        return Promise.resolve(response.data);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getAllBrands = async () => {
    try {
        const response = await getBrands();
        return Promise.resolve(response.data);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getAllVehicleModels = async (id: string) => {
    try {
        const response = await getVehicleModels(id);
        return Promise.resolve(response.data);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const registerIVUser = async (data: Record<string, unknown>) => {
    try {
        const response = await registerIV(data);
        return Promise.resolve(response.data);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const updateNewPassword =
    (data: Record<string, unknown>, token: string) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await recoverPassword(data, token);

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const resendPasswordRecoveryEmail =
    (data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await resendPasswordRecoveryEmailApi(data);

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const checkIfEmailCanBeResentNow =
    (data: Record<string, unknown>) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await checkIfEmailCanBeResentNowApi(data);

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const submitFeedback =
    (data: Record<string, unknown>, token: string) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await submitFeedbackApi(data, token);

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const resetNoResultFound = () => (dispatch: Dispatch) => {
    dispatch({
        type: NO_RESULT_FOUND,
        payload: { status: false },
    });
};

export const downloadAPK =
    (applicationMetaId: number, showToast: any) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await downloadAPKByVersion(
                {
                    applicationMetaId,
                },
                TokenService.getLocalAccessToken()
            );

            const href = window.URL.createObjectURL(response.data);

            const anchorElement = document.createElement("a");

            anchorElement.href = href;
            anchorElement.download = "application.apk";

            document.body.appendChild(anchorElement);
            anchorElement.click();

            document.body.removeChild(anchorElement);
            window.URL.revokeObjectURL(href);
        } catch (err: any) {
            showToast("Requested apk file does not exist.", "failed");
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const fetchAgreements = async () => {
    try {
        const response = await fetchAgreementApi();
        return Promise.resolve(response.data);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const uploadCertificate =
    (id: string, data: FormData, showToast: any) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const res = await uploadCertificateAPI(id, data, (event) => console.log(event));

            dispatch({
                type: UPLOAD_CERTIFICATE,
                payload: res.data.data,
            });

            showToast("Certificate was successfully submitted.", "success");
            return Promise.resolve(res?.data?.data || {});
        } catch (err: any) {
            showToast(err?.response?.data?.errorMessage ?? err?.errorMessage, "error");
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };

export const fetchCertificate = (id: string) => async (): Promise<any> => {
    try {
        const response = await fetchCertificateAPI(id);
        return Promise.resolve(response.data?.data);
    } catch (err: any) {
        return Promise.reject(err);
    }
};
